import { Column } from "../objects/column";
import { Site } from "../objects/site";
import { SiteErrors } from "../objects/siteErrors";
import { SiteListConfiguration } from "../objects/siteListConfiguration";
import { SiteListCriteria } from "../objects/siteListCriteria";
import { SiteListFiltersCriteria } from "../objects/siteListFiltersCriteria";

export const EMPTY_SITE: Site = {
    activated_module: [],
    background_color: "#1B2E50",
    button_color: "#D6057F",
    created_date: undefined,
    creator: null,
    footer_elements: [],
    id: 0,
    invoice_prefix: "",
    last_author: null,
    localization: [],
    logo: null,
    modified_date: null,
    pictures: [],
    sub_domain: "",
    text_color: "#1B2E50",
    agent: [],
    brand: null,
    is_simple_site: false,
    sub_domain_is_simple_site: ""
};

export const EMPTY_SITE_FILTERS: SiteListFiltersCriteria = {
    name: "",
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_SITE_LIST_CRITERIA: SiteListCriteria = {
    limit: 10,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_SITE_FILTERS,
    search: ''
};

export const EMPTY_SITE_ERRORS: SiteErrors = {
    sub_domain_error: "",
    sub_domain_is_simple_site_error: ""
};

export const SITE_INFO_ROUTE = '/site/edit/:id/info';
export const SITE_CONTACT_ROUTE = '/site/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
},
{
    label: 'site-url',
    field_name: 'EVENT_URL',
    checked: true,
    order_by: 'sub_domain',
    fixed_width: false,
    last_updated: false,
    width: null
},
{
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
},
{
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
},
{
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
},
{
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_SITE_LIST_CONFIGURATION: SiteListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const SITE_MODULE = 'SITE';
